import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useMutation } from "@apollo/client";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

import { REFUND_BOOKING, LOOKUP_FILTERED_BOOKINGS } from "../../queries/GraphQLQueries";
import CustomAlert from "../CustomAlert";
import { useDialogNavigation } from "../../hooks/useDialogNavigation";

export default function RefundBookingDialog() {
    const handleCancel = useDialogNavigation();
    const { state } = useLocation();
    const { bookingId, childName, serviceTypeDescription } = state || {};
    const [alertMessage, setAlertMessage] = useState(null);
    const [refundBookingMutation] = useMutation(REFUND_BOOKING, {
        refetchQueries: [{query: LOOKUP_FILTERED_BOOKINGS}, 'GetFilteredBookings']
    });

    const handleCloseCustomAlert = () => {
        setAlertMessage(null);
    };

    function handleRefund() {
        setAlertMessage({ children: "Refunding booking ...", severity: 'success' });
        refundBookingMutation({
            variables: {
                bookingId: bookingId
            }
        }).then(() => {
            handleCancel();
            setAlertMessage({ children: "Booking has been refunded.", severity: 'success' });
        }).catch((e) => {
            setAlertMessage({ children: e?.message, severity: 'error' });
        });
    }

    return <>
        <Dialog open={true} onClose={handleCancel} aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description" disableRestoreFocus>

            <DialogTitle id="confirmation-dialog-title33">Refund Confirmation</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description33">
                    This will refund "<b>{childName}'s</b>" {serviceTypeDescription} allocation from the booking.
                    <br></br> <br></br>
                    Do you want to proceed?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary" variant="contained">
                    Cancel
                </Button>
                <Button onClick={handleRefund} color="primary" variant="contained">
                    Refund
                </Button>
            </DialogActions>
        </Dialog>
        <CustomAlert alertMessage={alertMessage} handleCloseCustomAlert={handleCloseCustomAlert} />
    </>;
}